import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {Box, Checkbox, Stack} from '@salesforce/retail-react-app/app/components/shared/ui'
import {
    ADD_FILTER,
    REMOVE_FILTER
} from '@salesforce/retail-react-app/app/pages/product-list/partials/refinements-utils'
import {accordionListBtnStyles} from './refinements.style'
import {pxToRem} from '../../../utills/pxToRem'
import useScrollToMoreButton from '../../../hooks/useScrollToMoreButton'

const CheckboxRefinements = ({filter, toggleFilter, selectedFilters}) => {
    const {formatMessage} = useIntl()
    const [showAll, setShowAll] = useState(false)
    const {setScrollToMore, moreButtonRef} = useScrollToMoreButton()

    const newValues = filter?.values?.filter(
        (item) => !(item.hitCount === 0 && !selectedFilters.includes(item.value))
    )
    filter.values = newValues

    const displayedValues = showAll ? filter.values : filter.values.slice(0, 3)

    const getToggleMessage = () => {
        return showAll ? `Less ${filter.label}s` : `More ${filter.label}s`
    }

    const toggleShowAllFilters = () => {
        setScrollToMore(!!showAll)
        setShowAll(!showAll)
    }

    return (
        <Stack spacing={1}>
            {displayedValues?.map((value) => {
                const isChecked = selectedFilters.includes(value.value)

                return (
                    <Checkbox
                        key={value.value}
                        isChecked={isChecked}
                        onChange={() => toggleFilter(value, filter.attributeId, isChecked)}
                        aria-label={formatMessage(isChecked ? REMOVE_FILTER : ADD_FILTER, value)}
                        lineHeight={'normal'}
                        fontWeight={isChecked ? 500 : 400}
                        sx={{
                            '.chakra-checkbox__label': {
                                marginLeft: pxToRem(7),
                                fontWeight: isChecked ? '500 !important' : '400 !important'
                            }
                        }}
                    >
                        {value.label}
                    </Checkbox>
                )
            })}
            {filter.values.length > 3 && (
                <Box ref={moreButtonRef} onClick={toggleShowAllFilters} sx={accordionListBtnStyles}>
                    {getToggleMessage()}
                </Box>
            )}
        </Stack>
    )
}

CheckboxRefinements.propTypes = {
    filter: PropTypes.object,
    toggleFilter: PropTypes.func,
    selectedFilters: PropTypes.array
}

export default CheckboxRefinements
